import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import Select from 'react-select';
import { useForm, Controller } from 'react-hook-form';


// components

import { GIButton, Modal as GIModal } from 'app-components';

// select options

import { Counties } from '../../common';

const StyledFormContainer = styled.div`
    display: flex;
    vertical-align: middle;
    align-items: center;
    justify-content: space-between;

    .or {
        padding: 5%;
    }
`;

// props

interface SearchFormProps {
    show: boolean;
    onHide: () => void;
    onSearch: (isZipcodeSearch: boolean, data: any) => void;
}

function AgentSearchFormContainer(props: SearchFormProps) {
    const { show, onHide, onSearch } = props;

    const SearchByZipcode = () => {

        const { register, handleSubmit, watch, formState: { errors }, control } = useForm({ defaultValues: {
            zipcode: '',
            distance: '',
            languagesSpoken: []
        } });

        const { languagesSpoken } = watch();

        const onSubmit = (values) => {
            onSearch(true, {...values, languagesSpoken});
        };

        return (
            <div className={'grid-col-5 mobile:grid-col-12'}>
                <div className='grid-row'>
                    <h4><FormattedMessage id='ga.search.zip.title' /></h4>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={'gi-component padding-y-3'}>
                        <label className="gi-regular_input__label padding-l-0" htmlFor="find_zipcode">
                            <FormattedMessage id="gaep.ins_company.zipcode"/> (required)
                        </label>
                        <input id={'find_zipcode'} className={'gi-input__input grid-col-12'} {...register('zipcode', { required: true })} />
                        {errors.zipcode && <span><FormattedMessage id='ga.agents.form.error.required' /></span>}
                    </div>
                    <div className={'gi-component padding-y-3'}>
                        <label className='gi-regular_input__label padding-l-0' htmlFor="find_within">
                            <FormattedMessage id='ga.agents.form.zip.within' />
                        </label>
                        <input id={'find_within'} className={'gi-input__input grid-col-12'} {...register('distance', { required: false })} />
                    </div>
                    <div className={'gi-component padding-y-3'}>
                        <label className='gi-regular_input__label padding-l-0' htmlFor="find_preferred_lang">
                            <FormattedMessage id='ga.agents.form.zip.preferred_language' />
                        </label>
                        <Controller
                            control={control}
                            name="languagesSpoken"
                            render={({ field: { value, onChange } }) => (
                              <Select
                                  inputId="find_preferred_lang"
                                  isMulti
                                  closeMenuOnSelect={false}
                                  options={Counties}
                                  onChange={onChange}
                                  value={value}
                                  hideSelectedOptions={false}
                                  defaultValue={null}
                              />
                            )}
                        />
                    </div>
                    <div className={'gi-component padding-y-3 text-center'}>
                      <GIButton id='search_by_zip_find_btn' labelId='gaep.ins_company.find' />
                    </div>
                </form>
            </div>
        )
    }

    const SearchByName = () => {
        const intlApi = useIntl();
        const { register, handleSubmit } = useForm();

        const onSubmit = (data) => {
            onSearch(false, data);
        }
        const firstNamePlaceholder = intlApi.formatMessage({ id:'ga.agents.form.placeholder.agent_first_name' });
        const lastNamePlaceholder = intlApi.formatMessage({ id:'ga.agents.form.placeholder.agent_last_name' });
        const businessNamePlaceholder = intlApi.formatMessage({ id:'ga.agents.form.placeholder.business_name' });
        return (
            <div className={'grid-col-5 mobile:grid-col-12'}>
                <div className='grid-row'>
                    <h4><FormattedMessage id='ga.search.name.title' /></h4>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={'gi-component padding-y-3'}>
                        <label className="gi-regular_input__label padding-l-0" htmlFor="find_firstname">
                            <FormattedMessage id='ga.agents.form.name.agent_first_name' />
                        </label>
                        <input id={'find_firstname'} className={'gi-input__input grid-col-12'} placeholder={firstNamePlaceholder} {...register('firstName', { required: false })} />
                    </div>
                    <div className={'gi-component padding-y-3'}>
                        <label className="gi-regular_input__label padding-l-0" htmlFor="find_lastname">
                            <FormattedMessage id='ga.agents.form.name.agent_last_name' />
                        </label>
                        <input id={'find_lastname'} className={'gi-input__input grid-col-12'} placeholder={lastNamePlaceholder} {...register('lastName', { required: false })} />
                    </div>
                    <div className={'gi-component padding-y-3'}>
                        <label className="gi-regular_input__label padding-l-0" htmlFor="find_businessname">
                            <FormattedMessage id='ga.agents.form.name.business_name' />
                        </label>
                        <input id={'find_businessname'} className={'gi-input__input grid-col-12'} placeholder={businessNamePlaceholder} {...register('companyName', { required: false })} />
                    </div>
                    <div className={'gi-component padding-y-3 text-center'}>
                      <GIButton id='search_by_name_find_btn' labelId='gaep.ins_company.find' />
                    </div>
                </form>
            </div>
        )
    }

    if (show) {
        return (
            <GIModal id='agents_search_modal'>
                <GIModal.Header id='agents_search_modal_title' titleId='ga.agents.form.title' onHide={onHide} />
                <GIModal.Body>
                    <h1><FormattedMessage id='ga.agents.form.title.sub' /></h1>
                    <StyledFormContainer>
                        <SearchByZipcode />
                        <div className="find_wrapper">
                            <div className="vertical-line"></div>
                            <div className="circle">
                                <div className="circle-text">OR</div>
                            </div>
                            <div className="vertical-line"></div>
                        </div>
                        <SearchByName />
                    </StyledFormContainer>
                </GIModal.Body>
            </GIModal>
        )
    }

    return null;
}

export default AgentSearchFormContainer;